import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import {
  Container,
  Grid,
  Segment,
  Header,
  Message,
  Checkbox,
  Dropdown,
  Divider
  // Popup,
  // Icon
} from 'semantic-ui-react';
import { Button, Form } from 'formik-semantic-ui';
import { AONTimeRange2 } from '../../_components/layout/AON';
import { UnsavedFormPrompt } from '../../_components/custom/UnsavedFormPropt';
import { setToast } from '../../store/ToastManagement';
import {
  servicesAPI,
  useCustomerPreferences,
  useLanceToCustomers
} from '../../_services';
import { useCurrentUser } from '../../_services/hooks';
import { history } from '../../_helpers';
import { chargingTypeOptions, offPeakOnlyOptions } from '../../utils';
import './customerDetail_styles.css';

const VAPID_PUBLIC_KEY =
  'BINwrJVOMH8RJ5xLek1bF0z8MrhXk3ZKlKP7R6wdZFQTAQ9fB3ZB2bo4TlYdT6KRPkAI7uRP8AjqT2rp7IdNGQ8';

const minutesToHoursMinsText = mins => {
  const hour = String(Math.floor(mins / 60)).padStart(2, '0');
  const minutes = String(mins % 60).padStart(2, '0');

  return hour + ':' + minutes;
};

const hoursMinsTextToMinutes = hoursMins => {
  const bits = hoursMins.split(':');
  const hour = parseInt(bits[0]);
  const minutes = parseInt(bits[1]);

  return hour * 60 + minutes;
};

const hourOptions = [...Array(48).keys()].map(idx => {
  return { text: minutesToHoursMinsText(idx * 30), value: idx * 30 };
});

export const CustomerPreferences = () => {
  const { currentUser, currentUserIsCustomer, customerId } = useCurrentUser();
  const {
    customerPreferences,
    setCustomerPreferences
  } = useCustomerPreferences(customerId);
  const lanceToCustomers = useLanceToCustomers(customerId);
  // TDTODO Choosing first Lance but customer may have multiple Lances
  const lanceTagId = lanceToCustomers.length
    ? lanceToCustomers[0].lance_tag_id
    : null;

  const [cbTouched, setCBTouched] = useState(false);
  const [savedToken, setSavedToken] = useState(false);
  const [overrideSubscription, setOverrideSubscription] = useState(false);
  const [init, setInit] = useState(true);
  const [cachedChargingType, setCachedChargingType] = useState(null);
  const [chargingTypeNotes, setChargingTypeNotes] = useState('');

  const [chargingTimesWeekday1Start, setChargingTimesWeekday1Start] = useState(
    22 * 60
  );
  const [chargingTimesWeekday1End, setChargingTimesWeekday1End] = useState(
    8 * 60
  );
  const [chargingTimesWeekday2Start, setChargingTimesWeekday2Start] = useState(
    12 * 60
  );
  const [chargingTimesWeekday2End, setChargingTimesWeekday2End] = useState(
    16 * 60
  );
  const [chargingTimesWeekend1Start, setChargingTimesWeekend1Start] = useState(
    22 * 60
  );
  const [chargingTimesWeekend1End, setChargingTimesWeekend1End] = useState(
    8 * 60
  );
  const [chargingTimesWeekend2Start, setChargingTimesWeekend2Start] = useState(
    12 * 60
  );
  const [chargingTimesWeekend2End, setChargingTimesWeekend2End] = useState(
    16 * 60
  );
  const [weekdayChargingTimesValid, setWeekdayChargingTimesValid] = useState(
    false
  );
  const [weekendChargingTimesValid, setWeekendChargingTimesValid] = useState(
    false
  );

  useEffect(() => {
    if (init && customerPreferences?.pref_charging_type) {
      // If no charging times defined, set defaults
      if (!customerPreferences.pref_weekday_charging_times_1)
        customerPreferences.pref_weekday_charging_times_1 = '22:00-08:00';
      if (!customerPreferences.pref_weekday_charging_times_2)
        customerPreferences.pref_weekday_charging_times_2 = '12:00-16:00';
      if (!customerPreferences.pref_weekend_charging_times_1)
        customerPreferences.pref_weekend_charging_times_1 = '22:00-08:00';
      if (!customerPreferences.pref_weekend_charging_times_2)
        customerPreferences.pref_weekend_charging_times_2 = '12:00-16:00';

      const chargingTimesWeekday1Start = hoursMinsTextToMinutes(
        customerPreferences.pref_weekday_charging_times_1.split('-')[0]
      );
      const chargingTimesWeekday1End = hoursMinsTextToMinutes(
        customerPreferences.pref_weekday_charging_times_1.split('-')[1]
      );
      const chargingTimesWeekday2Start = hoursMinsTextToMinutes(
        customerPreferences.pref_weekday_charging_times_2.split('-')[0]
      );
      const chargingTimesWeekday2End = hoursMinsTextToMinutes(
        customerPreferences.pref_weekday_charging_times_2.split('-')[1]
      );
      const chargingTimesWeekend1Start = hoursMinsTextToMinutes(
        customerPreferences.pref_weekend_charging_times_1.split('-')[0]
      );
      const chargingTimesWeekend1End = hoursMinsTextToMinutes(
        customerPreferences.pref_weekend_charging_times_1.split('-')[1]
      );
      const chargingTimesWeekend2Start = hoursMinsTextToMinutes(
        customerPreferences.pref_weekend_charging_times_2.split('-')[0]
      );
      const chargingTimesWeekend2End = hoursMinsTextToMinutes(
        customerPreferences.pref_weekend_charging_times_2.split('-')[1]
      );

      setChargingTimesWeekday1Start(chargingTimesWeekday1Start);
      setChargingTimesWeekday1End(chargingTimesWeekday1End);
      setChargingTimesWeekday2Start(chargingTimesWeekday2Start);
      setChargingTimesWeekday2End(chargingTimesWeekday2End);
      setChargingTimesWeekend1Start(chargingTimesWeekend1Start);
      setChargingTimesWeekend1End(chargingTimesWeekend1End);
      setChargingTimesWeekend2Start(chargingTimesWeekend2Start);
      setChargingTimesWeekend2End(chargingTimesWeekend2End);

      setCachedChargingType(customerPreferences.pref_charging_type);
      setChargingType(customerPreferences.pref_charging_type);
      setInit(false);
    }
  }, [init, customerPreferences]);

  useEffect(() => {
    updatePushMessaging();
  }, [overrideSubscription]); // eslint-disable-line

  useEffect(() => {
    setCustomerPreferences({
      ...customerPreferences,
      pref_weekday_charging_times_1:
        minutesToHoursMinsText(chargingTimesWeekday1Start) +
        '-' +
        minutesToHoursMinsText(chargingTimesWeekday1End),
      pref_weekday_charging_times_2:
        minutesToHoursMinsText(chargingTimesWeekday2Start) +
        '-' +
        minutesToHoursMinsText(chargingTimesWeekday2End),
      pref_weekend_charging_times_1:
        minutesToHoursMinsText(chargingTimesWeekend1Start) +
        '-' +
        minutesToHoursMinsText(chargingTimesWeekend1End),
      pref_weekend_charging_times_2:
        minutesToHoursMinsText(chargingTimesWeekend2Start) +
        '-' +
        minutesToHoursMinsText(chargingTimesWeekend2End)
    });

    setWeekdayChargingTimesValid(
      chargingTimesWeekday2Start >= chargingTimesWeekday1End &&
        (chargingTimesWeekday2Start <= chargingTimesWeekday2End ||
          chargingTimesWeekday2Start <= chargingTimesWeekday1Start)
    );
    setWeekendChargingTimesValid(
      chargingTimesWeekend2Start >= chargingTimesWeekend1End &&
        (chargingTimesWeekend2Start <= chargingTimesWeekend2End ||
          chargingTimesWeekend2Start <= chargingTimesWeekend1Start)
    );
  }, [
    chargingTimesWeekday1Start,
    chargingTimesWeekday1End,
    chargingTimesWeekday2Start,
    chargingTimesWeekday2End,
    chargingTimesWeekend1Start,
    chargingTimesWeekend1End,
    chargingTimesWeekend2Start,
    chargingTimesWeekend2End
  ]); // eslint-disable-line

  const dispatch = useDispatch();
  const displaySuccessMessage = () =>
    dispatch(
      setToast({
        title: 'Success!',
        body: 'Preferences saved.'
      })
    );

  const _handleSubmit = (values, formikApi) => {
    // Changed preference for charging type? Rearbitrate
    if (values.pref_charging_type !== cachedChargingType && lanceTagId) {
      const values = { override_charge_rate: -1 };
      servicesAPI.InventoryServices('updateLance', values, lanceTagId).then(
        response => {},
        error => {}
      );
      setCachedChargingType(values.pref_charging_type);
    }

    values = {
      ...values,
      id: customerId
    };

    servicesAPI.CustomerServices('updatePreferences', values, customerId).then(
      response => {
        displaySuccessMessage();
        setCustomerPreferences(values);
        formikApi.resetForm();
      },
      error => {
        formikApi.setSubmitting(false);
        formikApi.setStatus({ error: error });
      }
    );
  };

  function urlB64ToUint8Array(base64String) {
    const padding = '='.repeat((4 - (base64String.length % 4)) % 4);
    const base64 = (base64String + padding)
      .replace(/-/g, '+')
      .replace(/_/g, '/');

    const rawData = window.atob(base64);
    const outputArray = new Uint8Array(rawData.length);

    for (let i = 0; i < rawData.length; ++i) {
      outputArray[i] = rawData.charCodeAt(i);
    }
    return outputArray;
  }

  const updatePushMessaging = () => {
    if (currentUser && !savedToken) {
      // Already registered?
      if ('serviceWorker' in navigator && 'PushManager' in window) {
        console.log('Service Worker and push messaging are supported');
        navigator.serviceWorker
          .getRegistration('/service_worker.js')
          .then(function(registration) {
            console.log('DEBUG: Registration=' + JSON.stringify(registration));
            if (registration) {
              registration.pushManager
                .getSubscription()
                .then(function(subscription) {
                  console.log(
                    'DEBUG: Subscription=' + JSON.stringify(subscription)
                  );
                  // Already subscribed on a device
                  if (subscription) {
                    if (overrideSubscription) {
                      setPushNotificationToken(subscription);
                      displaySuccessMessage('Updated notification device');
                    }
                    setSavedToken(true);
                  } else {
                    registration.pushManager
                      .subscribe({
                        userVisibleOnly: true,
                        applicationServerKey: urlB64ToUint8Array(
                          VAPID_PUBLIC_KEY
                        )
                      })
                      .then(function(subscription) {
                        console.log(
                          'DEBUG: Subscription=' + JSON.stringify(subscription)
                        );
                        setPushNotificationToken(subscription);
                        displaySuccessMessage('Updated notification device');
                        setSavedToken(true);
                      });
                  }
                });
            }
          });
      } else {
        alert('Service Worker or push messaging are not supported');
        console.log('Service Worker or push messaging are not supported');
      }
    }
  };

  const setPushNotificationToken = subscription => {
    if (!currentUser) {
      return;
    }

    if (Notification.permission === 'denied') {
      console.log('Notification permission denied');
      subscription = '';
    } else {
      console.log('Notification permission allowed');
      subscription = subscription === null ? '' : subscription;
    }

    const data = {
      push_notification_token: subscription
    };

    servicesAPI
      .CustomerServices('setPushNotificationToken', data, currentUser.id)
      .then(
        response => {},
        error => {}
      );
  };

  const sendNotification = message => {
    if (!currentUser) return;

    const values = {
      message: `${message}::/customer/preferences`
    };

    servicesAPI.CustomerServices('notifyUser', currentUser.id, values).then(
      response => {},
      error => {}
    );

    displaySuccessMessage('Sent test notification');
  };
  const setChargingType = type => {
    // AONTODO implement 'Timed' charging preference
    if (type === 'Fastest')
      setChargingTypeNotes(
        'Charge immediately as soon as the Trojan Lance and EV are plugged in.'
      );
    else if (type === 'Cheapest')
      setChargingTypeNotes(
        'Schedule charging to begin during off peak period if a cheaper evening tariff is available.'
      );
    else if (type === 'Timed')
      setChargingTypeNotes(
        'Schedule charging to begin within specific time periods.'
      );
  };

  if (!currentUser) {
    return <div>Loading...</div>;
  }
  if (!currentUserIsCustomer) {
    history.push(`/404`);
  }

  return (
    <div>
      <div
        style={{
          backgroundImage: "url('/images/background.jpg')"
        }}
        className="bgimage-app fade-in"
      />
      <Container>
        <Grid centered padded>
          <Grid.Column style={{ maxWidth: 500 }}>
            <Form
              ignoreLoading
              onSubmit={_handleSubmit}
              initialValues={customerPreferences}
              enableReinitialize={true}
            >
              {({
                values,
                errors,
                status,
                touched,
                isSubmitting,
                handleChange,
                setFieldValue,
                values: customerPreferences
              }) => (
                <div
                  style={{
                    marginBottom: '0px',
                    minHeight: '660px',
                    paddingLeft: '0px',
                    paddingRight: '0px',
                    paddingBottom: '0px'
                  }}
                >
                  <Segment>
                    <UnsavedFormPrompt when={!!Object.keys(touched).length} />
                    <Grid columns={1}>
                      <Grid.Row>
                        <Grid.Column textAlign="center">
                          <Header as="h2">PREFERENCES</Header>
                        </Grid.Column>
                      </Grid.Row>
                      {!!Object.keys(errors).length && (
                        <Grid.Column width={16}>
                          <Message negative visible>
                            Please correct requirements in the form
                          </Message>
                        </Grid.Column>
                      )}
                    </Grid>
                    <Grid columns={1} divided stackable>
                      <Grid.Row>
                        <Grid.Column>
                          <Header
                            sub
                            color="grey"
                            as="h3"
                            style={{ marginBottom: '10px' }}
                          >
                            Permissions
                          </Header>
                          <Checkbox
                            toggle
                            label="Send me service notifications"
                            name="allowNotifications"
                            checked={
                              customerPreferences.pref_allow_push_notifications
                            }
                            onChange={e => {
                              setCBTouched(true);
                              setOverrideSubscription(
                                !customerPreferences.pref_allow_push_notifications
                              );
                              setCustomerPreferences({
                                ...customerPreferences,
                                pref_allow_push_notifications: !customerPreferences.pref_allow_push_notifications
                              });
                            }}
                          />
                          {customerPreferences.pref_allow_push_notifications && (
                            <Button
                              color="olive"
                              onClick={() => {
                                sendNotification(
                                  'This is a test notification from Trojan Energy'
                                );
                              }}
                              disabled={currentUser?.impersonating}
                            >
                              Test
                            </Button>
                          )}
                          <br />
                          <br />
                          {/*<Checkbox
                            toggle
                            label="Allow up to 10 minute delay before starting charging"
                            name="allowTenMinuteChargingDelay"
                            checked={
                              customerPreferences.pref_allow_randomised_charging_delay
                            }
                            onChange={e => {
                              setCBTouched(true);
                              setOverrideSubscription(
                                !customerPreferences.pref_allow_randomised_charging_delay
                              );
                              setCustomerPreferences({
                                ...customerPreferences,
                                pref_allow_randomised_charging_delay: !customerPreferences.pref_allow_randomised_charging_delay
                              });
                            }}
                          />*/}
                          {/*<Popup
                            content={
                              'This is a legal requirement to attempt to balance demand on the electricity grid.'
                            }
                            trigger={
                              <Icon
                                color="grey"
                                name="info circle outline"
                                style={{ color: 'teal', fontSize: '14px' }}
                              />
                            }
                          />*/}
                          <Checkbox
                            toggle
                            label="Share my location"
                            name="shareMyLocation"
                            checked={customerPreferences.pref_share_location}
                            onChange={e => {
                              setCBTouched(true);
                              setCustomerPreferences({
                                ...customerPreferences,
                                pref_share_location: !customerPreferences.pref_share_location
                              });
                            }}
                          />
                          <Divider />
                          <Header
                            sub
                            color="grey"
                            as="h3"
                            style={{ marginBottom: '10px' }}
                          >
                            EV Charging Type
                          </Header>
                          <Dropdown
                            selection
                            search
                            options={chargingTypeOptions}
                            onChange={(e, inputProps) => {
                              setCBTouched(true);
                              setCustomerPreferences({
                                ...customerPreferences,
                                pref_charging_type: inputProps.value
                              });
                              setChargingType(inputProps.value);
                            }}
                            value={customerPreferences.pref_charging_type}
                          />
                          <br />
                          {chargingTypeNotes}
                          <br />
                          <br />
                          {customerPreferences.pref_charging_type ===
                          'Timed' ? (
                            <React.Fragment>
                              <div
                                className="aon-frame-flex-box"
                                style={{ overflow: 'initial' }}
                              >
                                <AONTimeRange2
                                  name="Weekday period 1"
                                  options={hourOptions}
                                  lowValue={chargingTimesWeekday1Start}
                                  setLowValue={value => {
                                    setChargingTimesWeekday1Start(value);
                                  }}
                                  highValue={chargingTimesWeekday1End}
                                  setHighValue={value => {
                                    setChargingTimesWeekday1End(value);
                                  }}
                                />
                                <br />
                                <AONTimeRange2
                                  name="Weekday period 2"
                                  options={hourOptions}
                                  lowValue={chargingTimesWeekday2Start}
                                  setLowValue={value => {
                                    setChargingTimesWeekday2Start(value);
                                  }}
                                  highValue={chargingTimesWeekday2End}
                                  setHighValue={value => {
                                    setChargingTimesWeekday2End(value);
                                  }}
                                />
                                {!weekdayChargingTimesValid ? (
                                  <div style={{ color: 'red' }}>
                                    Weekday periods cannot overlap
                                    <br />
                                  </div>
                                ) : (
                                  ''
                                )}
                                <br />
                                <AONTimeRange2
                                  name="Weekend period 1"
                                  options={hourOptions}
                                  lowValue={chargingTimesWeekend1Start}
                                  setLowValue={value => {
                                    setChargingTimesWeekend1Start(value);
                                  }}
                                  highValue={chargingTimesWeekend1End}
                                  setHighValue={value => {
                                    setChargingTimesWeekend1End(value);
                                  }}
                                />
                                <br />
                                <AONTimeRange2
                                  name="Weekend period 2"
                                  options={hourOptions}
                                  lowValue={chargingTimesWeekend2Start}
                                  setLowValue={value => {
                                    setChargingTimesWeekend2Start(value);
                                  }}
                                  highValue={chargingTimesWeekend2End}
                                  setHighValue={value => {
                                    setChargingTimesWeekend2End(value);
                                  }}
                                />
                                {!weekendChargingTimesValid ? (
                                  <div style={{ color: 'red' }}>
                                    Weekend periods cannot overlap
                                    <br />
                                  </div>
                                ) : (
                                  ''
                                )}
                              </div>
                            </React.Fragment>
                          ) : (
                            ''
                          )}
                          {customerPreferences.pref_charging_type ===
                          'Cheapest' ? (
                            <React.Fragment>
                              <Dropdown
                                selection
                                search
                                options={offPeakOnlyOptions}
                                onChange={(e, inputProps) => {
                                  setCustomerPreferences({
                                    ...customerPreferences,
                                    pref_cheapest_tariff: inputProps.value
                                  });
                                }}
                                value={
                                  customerPreferences.pref_cheapest_tariff
                                    ? customerPreferences.pref_cheapest_tariff
                                    : false
                                }
                              />
                            </React.Fragment>
                          ) : (
                            ''
                          )}
                        </Grid.Column>
                      </Grid.Row>
                    </Grid>
                  </Segment>
                  <Button.Submit
                    style={{
                      width: '100%'
                    }}
                    primary
                    type="submit"
                    disabled={
                      isSubmitting ||
                      !cbTouched ||
                      !!Object.keys(touched).length ||
                      currentUser?.impersonating
                    }
                    loading={isSubmitting}
                    color="olive"
                  >
                    SAVE PREFERENCES
                  </Button.Submit>
                </div>
              )}
            </Form>
          </Grid.Column>
        </Grid>
      </Container>
    </div>
  );
};
